// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnswerDotsPanel_wrapper__2sy-8","dot":"AnswerDotsPanel_dot__3sl55"};